export default __webpack_public_path__ + "static/media/nav-group.79b7468b.svg";